import { useDisclosure } from '@chakra-ui/hooks';
import React, { useRef, useState } from 'react';
import firebase from '../Helpers/Firebase';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    Button,
    Textarea,
    useToast
  } from "@chakra-ui/react"

  

const firestore = firebase.firestore();


export default function InitialFocus(props) {
  
    const initialRef = useRef();
    const finalRef = useRef();
    const hostsRef = firestore.collection('users');
    const toast = useToast();


    const initialValues = {
        fullName: '',
  
        email: '',
   

    }

    const [values, setValues] = useState(initialValues);
    const [isLoading, setLoading] = useState(false);



    const handleChange = e => {
        var { name, value } = e.target;
        setValues({
            ...values, 
            [name]: value,
        })

    }

    const addUser = async(e) => {
        e.preventDefault();
        setLoading(true)

        await hostsRef.add({
            fullName: values.fullName,
      
            email: values.email,
        
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          });
          toast({
            title: "Thank you.",
            description: "Thank you for signing up.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
      
          setLoading(false);

        setValues({...initialValues});
        e.target.reset();
    }


    return (
        
      <div>

        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={props.isOpen}
          onClose={props.onClose}

        >
          <ModalOverlay />
          <ModalContent m={4}>
              
            <ModalHeader>Early Sign Up!</ModalHeader>
            <ModalCloseButton />
            <form onSubmit={addUser}>
            <ModalBody pb={6}>
              <FormControl >
                <FormLabel>Full name</FormLabel>
                <Input ref={initialRef} placeholder="Full Name" name="fullName" onChange={handleChange} />
              </FormControl>
              <FormControl mt={5}>
                <FormLabel>Email</FormLabel>
                <Input ref={finalRef} placeholder="Email" type="email" name="email" onChange={handleChange} />
              </FormControl>
    

            </ModalBody>
            <ModalFooter>
              <Button  type="submit" colorScheme="blue" mr={3}       isLoading={isLoading}  
                            disabled={(values.email && values.fullName) ? false : true}>
                Submit
              </Button>
              <Button onClick={props.onClose}>Cancel</Button>
            </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </div>
    )
  }